import { render, staticRenderFns } from "./HomepageNews.vue?vue&type=template&id=31d2badf&scoped=true&"
import script from "./HomepageNews.vue?vue&type=script&lang=ts&"
export * from "./HomepageNews.vue?vue&type=script&lang=ts&"
import style0 from "./HomepageNews.vue?vue&type=style&index=0&id=31d2badf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2badf",
  null
  
)

export default component.exports